var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"RowImg"}},_vm._l((_vm.data.mediaContent),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('img',{attrs:{"src":item.mediaContent[0].url,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }